
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { NoticeArea } from '../noticeArea';

@Component({ components: { NoticeArea } })
export default class DispatchRequestSection extends Vue {
  @Prop({ default: '' }) readonly templateSubject!: string;

  @Prop({ default: '' }) readonly templateBody!: string;

  @Prop({ default: '' }) readonly statusBody!: string;

  @Prop({ default: false }) readonly isSending!: boolean;

  @Prop({ default: false }) readonly isEmergencyTimeSet!: boolean;

  @Prop({ default: false }) readonly hasEmergencyForecast!: boolean;

  @Prop({ default: false }) readonly disabled!: boolean;

  draftSubject = '';

  draftBody = '';

  dirty = false;

  @Watch('templateSubject', { immediate: true })
  onTemplateSubjectChange(value: string) {
    if (this.dirty) return;
    this.draftSubject = value ?? '';
  }

  @Watch('templateBody', { immediate: true })
  onTemplateBodyChange(value: string) {
    if (this.dirty) return;
    this.draftBody = value ?? '';
  }

  get fullBody(): string {
    const template = this.draftBody ?? '';
    const status = this.statusBody ?? '';
    return status ? `${template}\n\n${status}` : template;
  }

  get sendButtonLabel(): string {
    return this.isSending ? '手動送信' : '手動送信・現況報告自動送信開始';
  }

  get primaryNotice(): string {
    if (!this.hasEmergencyForecast) return '※緊急放流が予測されていません';
    if (!this.isEmergencyTimeSet) return '※緊急放流予定時刻が未設定です';
    return '';
  }

  get secondaryNotice(): string {
    if (!this.hasEmergencyForecast && !this.isEmergencyTimeSet) {
      return '※緊急放流予定時刻が未設定です';
    }
    return '';
  }

  onSubjectInput(value: string) {
    this.draftSubject = value;
    this.updateDirty();
  }

  onBodyInput(value: string) {
    this.draftBody = value;
    this.updateDirty();
  }

  updateDirty() {
    this.dirty = this.draftSubject !== this.templateSubject
      || this.draftBody !== this.templateBody;
  }
}
